/**
 * Crew Module Constants
 * Centralized constants for colors, statuses, and other configuration
 */

export const COMPLIANCE_COLORS = {
  compliant: 'text-green-700 bg-green-50 ring-green-600/20',
  warning: 'text-yellow-700 bg-yellow-50 ring-yellow-600/20',
  error: 'text-red-700 bg-red-50 ring-red-600/20',
  default: 'text-gray-700 bg-gray-50 ring-gray-600/20'
};

export const STATUS_COLORS = {
  'Active': 'text-green-700 bg-green-50 ring-green-600/20',
  'On Leave': 'text-gray-700 bg-gray-50 ring-gray-600/20',
  'Off Duty': 'text-yellow-700 bg-yellow-50 ring-yellow-600/20',
  default: 'text-gray-700 bg-gray-50 ring-gray-600/20'
};

export const CREW_STATUSES = ['Active', 'On Leave', 'Off Duty'];

export const FILTER_OPTIONS = {
  status: ['all', 'active', 'on leave', 'off duty'],
  compliance: ['all', 'compliant', 'warning', 'error']
};

export const EXPIRY_THRESHOLDS = {
  medical: {
    error: 0,    // Days - expired
    warning: 30  // Days - expiring soon
  },
  certificate: {
    error: 0,    // Days - expired
    warning: 60  // Days - expiring soon
  }
};

export const HOURS_OF_REST = {
  minimumDaily: 10,    // Hours per day
  minimumWeekly: 77,   // Hours per week
  daysToCheck: 7       // Days to check for weekly calculation
};